import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useState } from 'react';
import { Button } from '../../Button/Button.js';
import { Icon } from '../../Icon/Icon.js';
import { DialogSize } from '../constraints.js';
import { CloseConfirmationDialog } from './CloseConfirmationDialog.js';
import { DialogWithDoubleEscape, useDialogClose } from './DialogWithDoubleEscape.js';

function FormDialog(_ref) {
  let {
    title,
    subtitle,
    children,
    onClose,
    size,
    buttons,
    loading,
    onSubmit,
    disabled,
    pt,
    confirmClose,
    dialogClassName: propsDialogClassName
  } = _ref;
  const [confirmVisible, setConfirmVisible] = useState(false);
  const dialogClassName = clsx('dialog-form', size, propsDialogClassName);
  const buttonsClassName = clsx('flex flex-row gap-3', size === DialogSize.sm ? 'flex-row-reverse' : null);
  const handleRequestClose = () => {
    if (confirmClose === null || confirmClose === void 0 ? void 0 : confirmClose.isDirty()) {
      setConfirmVisible(true);
    } else {
      onClose();
    }
  };
  function HeaderContent() {
    var _a, _b, _c;
    const close = useDialogClose();
    const closeButton = buttons === null || buttons === void 0 ? void 0 : buttons.closeButton;
    const buttonsTemplate = jsxs(Fragment, {
      children: [jsx(Button, {
        loading: loading,
        disabled: disabled,
        label: (_a = buttons === null || buttons === void 0 ? void 0 : buttons.submitLabel) !== null && _a !== void 0 ? _a : 'Save',
        icon: buttons === null || buttons === void 0 ? void 0 : buttons.submitIcon,
        iconPos: buttons === null || buttons === void 0 ? void 0 : buttons.submitIconPos,
        onClick: () => {
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
      }), jsx(Button, {
        disabled: loading,
        label: (_b = closeButton === null || closeButton === void 0 ? void 0 : closeButton.label) !== null && _b !== void 0 ? _b : 'Close',
        severity: "secondary",
        onClick: () => {
          if (closeButton === null || closeButton === void 0 ? void 0 : closeButton.callback) {
            closeButton.callback();
          }
          if (!(closeButton === null || closeButton === void 0 ? void 0 : closeButton.overrideDefault)) {
            close();
          }
        }
      })]
    });
    return jsxs("div", {
      className: "flex flex-row justify-content-between align-items-center",
      children: [jsxs("div", {
        className: "flex flex-column gap-1",
        children: [jsx("div", {
          className: "flex align-items-center",
          children: title
        }), subtitle ? jsx("div", {
          className: "text-secondary text-sm font-normal text-transform-none",
          children: subtitle
        }) : null]
      }), [DialogSize.md, DialogSize.lg].includes(size) ? jsxs("div", {
        className: buttonsClassName,
        children: [(_c = buttons === null || buttons === void 0 ? void 0 : buttons.content) !== null && _c !== void 0 ? _c : null, !(buttons === null || buttons === void 0 ? void 0 : buttons.content) && buttonsTemplate]
      }) : jsx(Button, {
        icon: jsx(Icon, {
          name: "cancel",
          fontSize: "normal"
        }),
        rounded: true,
        text: true,
        onClick: () => {
          if (closeButton === null || closeButton === void 0 ? void 0 : closeButton.callback) {
            closeButton.callback();
          }
          if (!(closeButton === null || closeButton === void 0 ? void 0 : closeButton.overrideDefault)) {
            close();
          }
        }
      })]
    });
  }
  function FooterContent() {
    var _a, _b;
    const close = useDialogClose();
    const closeButton = buttons === null || buttons === void 0 ? void 0 : buttons.closeButton;
    return jsxs(Fragment, {
      children: [jsx(Button, {
        loading: loading,
        disabled: disabled,
        label: (_a = buttons === null || buttons === void 0 ? void 0 : buttons.submitLabel) !== null && _a !== void 0 ? _a : 'Save',
        icon: buttons === null || buttons === void 0 ? void 0 : buttons.submitIcon,
        iconPos: buttons === null || buttons === void 0 ? void 0 : buttons.submitIconPos,
        onClick: () => {
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
      }), jsx(Button, {
        disabled: loading,
        label: (_b = closeButton === null || closeButton === void 0 ? void 0 : closeButton.label) !== null && _b !== void 0 ? _b : 'Close',
        severity: "secondary",
        onClick: () => {
          if (closeButton === null || closeButton === void 0 ? void 0 : closeButton.callback) {
            closeButton.callback();
          }
          if (!(closeButton === null || closeButton === void 0 ? void 0 : closeButton.overrideDefault)) {
            close();
          }
        }
      })]
    });
  }
  return jsxs(Fragment, {
    children: [jsx(DialogWithDoubleEscape, {
      onClose: onClose,
      onBeforeClose: confirmClose ? handleRequestClose : undefined,
      doubleEscapeEnabled: !confirmVisible,
      className: dialogClassName,
      header: jsx(HeaderContent, {}),
      footer: size !== DialogSize.sm ? undefined : jsx(FooterContent, {}),
      pt: pt,
      children: children
    }), confirmClose && jsx(CloseConfirmationDialog, {
      visible: confirmVisible,
      config: confirmClose,
      onCancel: () => setConfirmVisible(false),
      onConfirm: () => {
        setConfirmVisible(false);
        onClose();
      }
    })]
  });
}

export { FormDialog };
